export enum Genders {
  FEMALE = 'Female',
  MALE = 'Male',
  NON_BINARY = 'Non-binary',
  NO_ANSWER = 'Prefer not to answer',
}
export default Genders;
